import { Image, Save, Upload } from 'lucide-react';

interface CoverUploadSectionProps {
  coverPreview: string | null;
  coverFile: File | null;
  onCoverChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function CoverUploadSection({ coverPreview, coverFile, onCoverChange }: CoverUploadSectionProps) {
  return (
    <div className='rounded-2xl border border-slate-200 bg-white p-8'>
      <h2 className='mb-6 flex items-center gap-2 text-lg font-bold text-slate-900'>
        <Image className='h-5 w-5 text-rose-500' />
        Affiche du concours
      </h2>
      <div className='flex flex-col md:flex-row items-start gap-8'>
        {/* Aperçu portrait 3:4 */}
        <div className='w-37.5 shrink-0'>
          <div className='flex aspect-3/4 items-center justify-center overflow-hidden rounded-2xl border-2 border-dashed border-slate-200 bg-slate-50'>
            {coverPreview ? (
              <img src={coverPreview} alt='Aperçu affiche' className='h-full w-full object-cover' />
            ) : (
              <div className='p-4 text-center'>
                <Save className='mx-auto mb-2 h-8 w-8 text-slate-200' />
                <p className='text-xs text-slate-400'>Aper&ccedil;u</p>
              </div>
            )}
          </div>
        </div>
        <div className='flex-1 space-y-4'>
          <p className='text-sm leading-relaxed text-slate-600'>
            L&apos;affiche est affich&eacute;e en portrait sur la page publique du concours.
            <br />
            <span className='font-semibold'>Ratio conseill&eacute; :</span> 3:4 — environ{' '}
            <span className='rounded bg-slate-100 px-1.5 py-0.5 font-mono text-xs'>425 × 567 px</span> minimum.
            <br />
            Formats accept&eacute;s : JPG, PNG, WebP (max 10 Mo).
          </p>
          <label className='inline-flex cursor-pointer items-center gap-2 rounded-xl border border-slate-200 px-5 py-3 text-sm font-semibold text-slate-700 transition-colors hover:border-blue-300 hover:text-blue-600'>
            <Upload className='h-4 w-4' />
            {coverPreview ? "Remplacer l'affiche" : 'Choisir une affiche'}
            <input type='file' accept='image/jpeg,image/png,image/webp' className='hidden' onChange={onCoverChange} />
          </label>
          {coverFile && (
            <p className='text-xs font-medium text-emerald-600'>
              {coverFile.name} — sera enregistr&eacute; avec les modifications
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
